module.exports = __webpack_public_path__ + "media/images/right_arrow-8fd46ef305103416ce7075c9ebffded8.svg";